import { useAuth } from '../../../contexts/AuthProvider';
import { Button, Form } from 'react-bootstrap';
import { Modal } from '../../../components/Modal';
import { Fields } from '../../../components/Fields';
import { useForm } from 'react-hook-form';
import { IField } from '../../../interfaces/field.interface';
import { IGlobalSearchFields } from './global-search.interface';
import { RoutesEnum } from '../../../routes/routes.enum';

const fields: Array<IField> = [
    {
        label: "Include Opening Balance",
        required: false,
        props: {
            name: "inc_bal",
            type: "switch",
        }
    }, {
        label: "Show Nil Accounts",
        required: false,
        props: {
            name: "shw_nil",
            type: "switch",
        }
    }, {
        label: "Show O/B Only",
        required: false,
        props: {
            name: "opn_bal",
            type: "switch",
        }
    }, {
        label: "Pending Status",
        required: false,
        props: {
            name: "status",
            type: "select",
            placeholder: "Pending Status"
        },
        options: [
            { id: "", name: "All" },
            { id: "P", name: "Pending" },
            { id: "C", name: "Cleared" },
        ]
    }, {
        label: "Upto Date",
        required: false,
        props: {
            name: "to_date",
            type: "date",
            inputMode: "text",
            placeholder: "Upto Date"
        }
    }
];

export default function AdvanceSearchModal() {
    const { globalSearch, setGlobalSearchFields, setShowSearchModal } = useAuth();

    const getFilterFields = (): Array<IField> => {
        let finalFields = [...fields];
        const pathName = window.location.pathname;
        if (pathName.indexOf(RoutesEnum.PurchaseOrderList) > -1 || pathName.indexOf(RoutesEnum.SaleOrderList) > -1) {
            finalFields = finalFields.filter(field => field.props.name === 'status');
        } else if (pathName.indexOf(RoutesEnum.AccountTrialBalance) > -1 || pathName.indexOf(RoutesEnum.AgentAccountTrialBalance) > -1) {
            finalFields = finalFields.filter(field => field.props.name !== 'status');
        }        
        return finalFields;
    }

    const { register, control, handleSubmit } = useForm<IGlobalSearchFields>({
        defaultValues: globalSearch.fields,
        mode: "onTouched",
        reValidateMode: "onChange"
    });

    const onSubmit = handleSubmit(async (inputs) => {
        setGlobalSearchFields(inputs);
        setShowSearchModal(false);
    });

    return (
        <Modal
            title="Advance Search"
            show={globalSearch.isOpen}
            handleClose={() => setShowSearchModal(false)}
        >
            <Form onSubmit={onSubmit} noValidate>
                <Fields fields={getFilterFields()} control={control} register={register} />
                <Button className='w-100 mt-3' variant='primary' type="submit">Submit</Button>
            </Form>
        </Modal>
    );
};